import { render, staticRenderFns } from "./BindsTextarea.vue?vue&type=template&id=013d8192&"
import script from "./BindsTextarea.vue?vue&type=script&lang=js&"
export * from "./BindsTextarea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports